var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5231 17.5798V19.3444L11.9766 20.25L10.4769 19.3444V17.5798L11.9766 18.4854L13.5231 17.5798ZM5.25 11.4694L6.75114 12.375V15.4069L9.34042 16.9454V18.7115L5.25 16.3125V11.4694ZM18.7046 11.4694V16.3125L14.5673 18.7115V16.9454L17.1581 15.4069V12.375L18.7046 11.4694ZM14.5673 9.07042L16.1139 9.97604V11.7406L13.5231 13.2806V16.3533L12.0234 17.2633L10.5223 16.3533V13.2806L7.84075 11.7406V9.97604L9.38729 9.07042L11.9766 10.6104L14.5673 9.07042ZM7.84075 13.0079L9.34042 13.9135V15.6781L7.84075 14.774V13.0079ZM16.1139 13.0079V14.774L14.6127 15.6781V13.9135L16.1139 13.0079ZM6.75114 7.53188L8.29621 8.4375L6.75114 9.34312V11.1033L5.25 10.2021V8.4375L6.75114 7.53188ZM17.2035 7.53188L18.75 8.4375V10.2021L17.2035 11.1033V9.34312L15.7038 8.4375L17.2035 7.53188ZM11.9766 7.53188L13.5231 8.4375L11.9766 9.34312L10.4769 8.4375L11.9766 7.53188ZM11.9766 4.5L16.1139 6.89896L14.6127 7.80312L12.0234 6.26458L9.38729 7.80312L7.88615 6.89896L11.9766 4.5Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.3dee39043f9471fc3730ab34946f4b4c.svg";
export { ForwardRef as ReactComponent };